<template>
	<el-form ref="form" label-position="top" v-loading="getScreenSize < 2 && !delayedLoading[5]"  element-loading-text="Loading...">
		<!-- {{getSettingsDevice}}
		<hr>
		{{getSettingsSpecval}} -->
		<el-row :gutter="25" v-if="getScreenSize > 1 || delayedLoading[1]">
			<el-col :lg="12">
				<el-form-item class="el-form-item-full" :label="$l('settings/device/Selection')">
					<el-select :loading="instrumentLoading" :disabled="getStatus.noise" v-model="getSettingsDevice.mic" :placeholder="$l('common/select')">
						<el-option :label="$l('settings/device/Standard')" value="IN0"></el-option>
						<el-option :label="$l('settings/device/iepe')" value="IN1"></el-option>
						<el-option :label="$l('settings/device/line')" value="IN2"></el-option>
						<el-option :label="$l('settings/device/horizontal')" value="IN3"></el-option>
						<el-option :label="$l('settings/device/vertical')" value="IN4"></el-option>
					</el-select>
				</el-form-item>
			</el-col> 

			<el-col :lg="12">
				<el-form-item class="el-form-item-full" :label="$l('settings/device/Polarisation')">
					<el-select :loading="instrumentLoading" :disabled="getStatus.noise" v-model="getSettingsDevice.micpol" :placeholder="$l('common/select')">
						<el-option :label="$l('settings/device/On')" value="VS1"></el-option>
						<el-option :label="$l('settings/device/Off')" value="VS0"></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			
			<el-col :lg="12">
				<el-form-item class="el-form-item-full" :label="$l('settings/device/Frequency')">
					<el-select :loading="instrumentLoading" :disabled="getStatus.noise" v-model="getSettingsDevice.freqmode" :placeholder="$l('common/select')">
						<el-option :label="$l('settings/device/Disable')" value="SC0"></el-option>
						<el-option :label="$l('settings/device/11octave')" value="SC1FA0"></el-option>
						<el-option :label="$l('settings/device/13octave')" value="SC1FA1"></el-option>
						<el-option :label="$l('settings/device/11wOctave')" value="SC1FA2"></el-option>
						<el-option :label="$l('settings/device/13wOctave')" value="SC1FA3"></el-option>
					</el-select>
				</el-form-item>
			</el-col>

			<el-col :lg="12">
				<el-form-item class="el-form-item-full" :label="$l('settings/device/Resolution')">
					<el-select :loading="instrumentLoading" :disabled="getStatus.noise" v-model="getSettingsDevice.resolution" :placeholder="$l('common/select')">
						<el-option label="50 ms" value="UN50"></el-option>
						<el-option label="100 ms" value="UN100"></el-option>
						<el-option label="125 ms" value="UN125"></el-option>
						<el-option label="500 ms" value="UN500"></el-option>
						<el-option label="1 s" value="US01"></el-option>
						<el-option label="5 s" value="US05"></el-option>
						<el-option label="1 min" value="US60"></el-option>
						<el-option label="10 min" value="US600"></el-option>
					</el-select>
				</el-form-item> 
			</el-col>

			<el-col :lg="12">
				<el-form-item class="el-form-item-full" :label="$l('settings/device/Duration')">
					<el-select :loading="instrumentLoading" :disabled="getStatus.noise" v-model="getSettingsDevice.duration" :placeholder="$l('common/select')">
						<el-option label="24 h" value="H24"></el-option>
						<el-option label="1 h" value="H01"></el-option>
					</el-select>
				</el-form-item>
			</el-col>

			<el-col :lg="24">
				<div class="infoContainer">
					<el-form-item class="el-form-item-full" :title="$l('settings/device/Meter')"> 
						<el-row>
							<el-col :span="8" style="text-align:center">
								<el-button :disabled="getSettingsDevice.meterscale <= 70" @click="decreaseClicked">{{$l('settings/device/decrease')}}</el-button>
							</el-col>
							<el-col :span="8" style="text-align:center; font-weight:600; font-size:16px">
								{{getSettingsDevice.meterscale - 80}} dB / {{getSettingsDevice.meterscale}} dB 
							</el-col>
							<el-col :span="8"  style="text-align:center">
								<el-button :disabled="getSettingsDevice.meterscale >= 130"  @click="increaseClicked">{{$l('settings/device/increase')}}</el-button>                                
							</el-col>                            
						</el-row>
					</el-form-item>
				</div>
			</el-col>

		</el-row>
		<el-collapse accordion v-if="getScreenSize > 1 || delayedLoading[2]">
			<el-collapse-item value='1' :title="$l('settings/device/Values')">
				<!-- EMPTY ROW WORK IN PROGRESS -->
				<el-row>
					<el-col :span="6">&nbsp;</el-col>
					<el-col :span="6" style="padding-left:5px">F</el-col>
					<el-col :span="3" style="padding-left:5px">S</el-col>
					<el-col :span="3" style="padding-left:5px">I</el-col>
					<el-col :span="3" style="padding-left:5px">I</el-col>
				</el-row>
				
				<el-row v-for="(value, i) in getSettingsDevice.valuesAll" v-bind:key="value[0]">
					<el-col :span="(value.length == 3)?6:9">
						<el-color-picker v-model="getUnsavedLocalSettings.interface.colorsnoise[i]"></el-color-picker><div class="value-name">{{getDeviceValueName(value)}}</div>
					</el-col>
					<el-checkbox-group class="value-checkbox" v-model="getSettingsDevice.valsel">
						<el-col v-for="subvalue in value" :span="6" v-bind:key="subvalue">
							<el-checkbox @change="checkboxChanged(subvalue)" :label="subvalue" ></el-checkbox>
						</el-col>
					</el-checkbox-group>
				</el-row>

				
			</el-collapse-item>
		</el-collapse>

		<el-collapse accordion v-if="getScreenSize > 1 || delayedLoading[3]">
			<el-collapse-item :title="$l('settings/device/Special')"> <!-- v drugem apiju -->
				<el-row v-for="item in getSettingsSpecval.valselsp" v-bind:key="item.name" :gutter="25">
					<el-col :lg="2">
						<el-form-item class="el-form-item-full" v-if="item.name == 'MV'" :label="$l('settings/device/movingValue')">
							<el-switch on-text="" off-text="" v-model="item.enabled"></el-switch>
						</el-form-item>
						<el-form-item class="el-form-item-full" v-if="item.name != 'MV'" :label="item.name">
							<el-switch on-text="" off-text="" v-model="item.enabled"></el-switch>
						</el-form-item>
					</el-col>
					<el-col  :lg="22">
						<el-form-item class="el-form-item-full" v-if="item.name == 'LEQDay' && item.enabled"> <!-- Fixes some ui problems. -->
							<div class="LEQDayContainer">
								<el-row :gutter="25">
									<el-col :sm="8" :md="8" :lg="6">
										<el-form-item class="el-form-item-full" :label="$l('settings/device/value')">
											<el-select v-model="getSettingsSpecval.leqday" :placeholder="$l('common/select')">
												<el-option :label="$l('settings/device/timeControlled')" value="tc"></el-option>
												<el-option :label="$l('settings/device/measurementControlled')" value="mc"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :sm="8" :md="8" :lg="11">
										<el-form-item class="el-form-item-full" :label="$l('settings/device/start_stop')"> 
											<el-row> <!-- Za poravnavo UI-ja -->
												<el-col>
													<!--<el-date-picker :disabled="getSettingsSpecval.leqday == 'mc'" v-model="dayStartStop" type="datetimerange"> </el-date-picker>-->
													<el-time-select :disabled="getSettingsSpecval.leqday == 'mc'" :placeholder="$l('settings/device/startTime')" v-model="getSettingsSpecval.leqdaystart" :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"></el-time-select>
													<el-time-select :disabled="getSettingsSpecval.leqday == 'mc'" :placeholder="$l('settings/device/endTime')" v-model="getSettingsSpecval.leqdaystop" :picker-options="{start: '00:00',step: '00:15',end: '24:00',minTime: getSettingsSpecval.leqdaystart}"></el-time-select>
												</el-col>
											</el-row>
										</el-form-item>
									</el-col>
									<el-col :sm="3" :md="3" :lg="3">
										 
										<el-form-item class="el-form-item-full" :label="$l('settings/device/trigger')"> 
											<el-row>
												<el-col>
													<el-input-number v-model="getSettingsSpecval.leqdayval"> </el-input-number>
												</el-col>
											</el-row>
										</el-form-item>                            
									</el-col>
								</el-row>
							</div>
						</el-form-item>
						<el-form-item class="el-form-item-full" v-if="item.name == 'MV' && item.enabled">
							<div class="LEQDayContainer">
								<el-row :gutter="25" >
									<el-col :lg="8">
										<el-form-item class="el-form-item-full" :label="$l('settings/device/value')"> 
											<el-select v-model="getSettingsSpecval.maval" :placeholder="$l('common/select')">
												<el-option :label="$l('settings/device/movingAverage')" value="ma"></el-option>
												<el-option label="L95" value="l95"></el-option>
												<el-option label="L50" value="l50"></el-option>
												<el-option label="L1" value="l1"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :lg="8">
										<el-form-item class="el-form-item-full" :label="$l('settings/device/duration')"> 
											<el-time-picker v-model="getSettingsSpecval.mavaldurationPicker"
												:picker-options="{
													selectableRange: '00:00:00 - 01:00:00'
												}">
											</el-time-picker>
											<el-input-number v-show="false" v-model="getSettingsSpecval.mavalduration" style="width:100%"> </el-input-number>
										</el-form-item>                            
									</el-col>
								</el-row>
								<el-row style="margin-top:20px" :gutter="20">
									<el-col :sm="12" :md="12" :lg="12">
										<el-form-item class="el-form-item-full" :label="$l('settings/device/threshold')">
											<el-select v-model="getSettingsSpecval.mavalltype" :placeholder="$l('common/select')">
												<el-option :label="$l('settings/audioRecording/Disable')" :value="0"></el-option> 
												<el-option :label="$l('settings/audioRecording/Lower')" :value="1"></el-option> 
												<el-option :label="$l('settings/audioRecording/Greater')" :value="2"></el-option> 
												<el-option :label="$l('settings/audioRecording/Both')" :value="3"></el-option> 
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-row :gutter="25">
											<el-col :sm="11" :lg="11">
												<el-form-item class="el-form-item-full pixel" :label="$l('settings/audioRecording/lowerThan')">
														<el-input-number :disabled="getSettingsSpecval.mavalltype == 0 || getSettingsSpecval.mavalltype == 2" v-model="getSettingsSpecval.mavallevel[0]" :min="0" :max="150" style="width: 100%;"></el-input-number>
												</el-form-item>
											</el-col>
											<el-col class="line" :sm="2" :lg="2">
												<el-form-item class="el-form-item-full pixel" label=" ">-</el-form-item>
											</el-col>
											<el-col :sm="11" :lg="11">
												<el-form-item class="el-form-item-full pixel" :label="$l('settings/audioRecording/greaterThan')">
														<el-input-number :disabled="getSettingsSpecval.mavalltype == 0 || getSettingsSpecval.mavalltype == 1" v-model="getSettingsSpecval.mavallevel[1]" :min="0" :max="150" style="width: 100%;"></el-input-number>
												</el-form-item>
											</el-col>
										</el-row>
									</el-col>
								</el-row>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				
			</el-collapse-item>
		</el-collapse>

		<el-collapse accordion v-if="getScreenSize > 1 || delayedLoading[4]">
			<el-collapse-item :title="$l('settings/device/Advance')">
				<el-row :gutter="25">
					<el-col :sm="12" :md="12" :lg="12">
						<el-form-item class="el-form-item-full" :label="$l('settings/device/Mic check')">
							<el-input-number v-model="getSettingsDevice.miccheckvalue" :min="-10" :max="140" :step="0.1"></el-input-number>
						</el-form-item>
					</el-col>
					 <el-col :sm="12" :md="12" :lg="12">
						<el-form-item class="el-form-item-full" :label="$l('settings/device/Mic check time')">
							<el-select v-model="getSettingsDevice.micchecktime" :placeholder="$l('common/select')">
								<el-option :label="$l('settings/device/midnight')" value="23"></el-option>
								<el-option :label="$l('settings/device/noon')" value="11"></el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :sm="12" :md="12" :lg="12">
						<el-form-item class="el-form-item-full" :label="$l('settings/device/testOpt')">
							<el-input disabled v-model="testOptionsValue"></el-input>
						</el-form-item>
					</el-col>
					<el-col class="pixel" :sm="12" :md="12" :lg="12">
						<el-form-item class="el-form-item-full" label=" ">
							<el-button @click="testOptions()">{{$l('settings/device/test')}}</el-button>
						</el-form-item>
					</el-col>
					<el-col class="pixel" :sm="12" :md="12" :lg="12">
					</el-col>
					<el-col :sm="12" :md="12" :lg="12">
						<el-form-item class="el-form-item-full" :label="$l('settings/device/SDFreeSpace')">
							<el-input-number v-model="getSettingsDevice.sdfreelimit"></el-input-number>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="25">
					<el-col :span="12" class="startstop-title">{{$l('settings/device/autostart')}}</el-col>
					<el-col :span="12"><el-button @click="addStartstopGroup" class="right-pull"  size="mini" type="success" icon="plus"></el-button></el-col>
					<el-col :span="24">
						<el-collapse accordion>
							<el-collapse-item v-for="(group, index) in getSettingsStartstop.groups" v-bind:key="group" :title="'Group '+ (index+1)">
								<el-row>
									<div class="remove-startstop-button"><el-button @click="deleteStartstopGroup(group)" class="right-pull" size="mini" type="danger" icon="delete"></el-button></div>

								</el-row>
								<el-row :gutter="25">
									<el-col :md="4">
										<el-form-item :label="$l('settings/device/startstopActive')">
											<el-switch v-model="getSettingsStartstop['enable'+group]" on-text="" off-text=""></el-switch>
										</el-form-item>
									</el-col>
									<el-col :md="10">
										<el-form-item :label="$l('settings/device/days')">
											<el-select :disabled="!getSettingsStartstop['enable'+group]" v-model="getSettingsStartstop['days'+group]" multiple>
												<el-option key="1" :label="$l('common/graph_day_name')[1]" value="1"></el-option>
												<el-option key="2" :label="$l('common/graph_day_name')[2]" value="2"></el-option>
												<el-option key="3" :label="$l('common/graph_day_name')[3]" value="3"></el-option>
												<el-option key="4" :label="$l('common/graph_day_name')[4]" value="4"></el-option>
												<el-option key="5" :label="$l('common/graph_day_name')[5]" value="5"></el-option>
												<el-option key="6" :label="$l('common/graph_day_name')[6]" value="6"></el-option>
												<el-option key="7" :label="$l('common/graph_day_name')[0]" value="7"></el-option>

											</el-select>
										</el-form-item>
										
									</el-col>
									<el-col :md="10">
										<el-form-item :label="$l('settings/device/types')">
											<el-select :disabled="!getSettingsStartstop['enable'+group]" v-model="getSettingsStartstop['types'+group]" multiple>
												<el-option key="noise" :label="$l('calendar/noise')" value="noise"></el-option>
												<el-option key="weather" :label="$l('calendar/weather')" value="weather"></el-option>
												<el-option key="adio" :label="$l('calendar/adio')" value="adio"></el-option>

											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="25">
									<el-col :md="12">
										<el-form-item :label="$l('settings/device/start')">
											<el-time-select :disabled="!getSettingsStartstop['enable'+group]"
												v-model="getSettingsStartstop['start'+group]"
												:picker-options="{
													start: '00:00',
													step: '00:15',
													end: '23:45'
												}">
											</el-time-select>
										</el-form-item>
									</el-col>
									<el-col :md="12">
										<el-form-item :label="$l('settings/device/stop')">
											<el-time-select :disabled="!getSettingsStartstop['enable'+group]"
												v-model="getSettingsStartstop['stop'+group]"
												:picker-options="{
													start: getSettingsStartstop['start'+group],
													step: '00:15',
													end: '23:45'
												}">
											</el-time-select>
										</el-form-item>
									</el-col>
								</el-row>
							</el-collapse-item>
						</el-collapse>
					</el-col>
				</el-row>
			</el-collapse-item>
		</el-collapse>
		<!--Format SD -->
		<el-dialog
			title="Format SD"
			:visible.sync="formatSDdialog"
			size="tiny"
			>
			<span>{{$l('settings/device/formatSDdialog')}} </span>
			<span slot="footer dialog-footer">
					<el-button @click="formatSDdialog =  false"> {{$l('settings/alertMessaging/dialogCancel')}} </el-button>
					<el-button type="primary" @click="formatSDdialog =  false, formatSD()"> {{$l('settings/alertMessaging/dialogContinue')}} </el-button>
			</span>
		</el-dialog>
		<el-row style="margin-top:20px" v-if="getScreenSize > 1 || delayedLoading[5]">
			<el-button :loading="restartLoading" type="info" @click="restartNoiseClick()">{{$l('settings/device/Restart')}}</el-button>
			<el-button :loading="instrumentLoading" :disabled="getStatus.noise" type="info" @click="setInstrument()">{{$l('settings/device/Set instrument')}}</el-button>
			<el-button :loading="formatSDLoading" :disabled="getStatus.noise" type="danger" @click="formatSD()">{{$l('settings/device/Format')}}</el-button>
			<el-button :loading="checkSpaceLoading" :disabled="getStatus.noise" type="info" @click="checkSD()">{{$l('settings/device/CheckSD')}}</el-button>
		</el-row>
	</el-form>
	
</template>

<style scoped>
	.right-pull{
		float:right;
	}
	.startstop-title{
		font-size: 16px;
		font-weight: 600;
	}
	.pixel{
		margin-top:1px;
	}
	.LEQDayContainer{
		padding:10px;
		border: 1px solid #e1e5ec;
		margin-top:3px;
	}
	.infoContainer{
		padding-top:20px;
		padding-bottom: 0px;
		border: 1px solid #e1e5ec;
		margin-top:3px;
		margin-bottom:25px;
		font-size:14px;
	}
	.el-checkbox{
		color:white;
	}
	.el-color-picker{
		transform: scale(0.7);
		float:left;
		margin-left: -10px;
	}
	.value-name{
		float: left;
		margin-top: 7px;
	}
	.value-checkbox{
		margin-top: 7px;
	}
	.meter-scale-value{
		font-weight: 600;
		font-size: 20px;
	}
</style>

<script>
import { mapGetters, mapActions } from 'vuex'
import {setNoise, restartNoise, sdFormatNoise, sdFreeNoise, testOptions, increaseVolume, decreaseVolume} from '@/store/actions'
export default {
	data() {
		return {
			restartLoading:false,
			instrumentLoading:false,
			formatSDLoading:false,
			checkSpaceLoading:false,
			formatSDdialog: false,
			testOptionsValue:'',
			delayedLoading:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0},
		}
	},
	computed:{
		...mapGetters([
			'getSettingsDevice',
			'getSettingsInterface',
			'getSettingsSpecval',
			'getUnsavedLocalSettings',
			'getStatus',
			'getScreenSize',
			'getSettingsStartstop'
		])
	},
	methods: {
		...mapActions([
			'updateStartstopSettings'
		]),
		onSubmit() {
			console.log('submit!');
		},
		setInstrument(){
			this.instrumentLoading = true;
			setTimeout(()=>{
				setNoise(this.$store)
					.then((data)=>{
						if (data.error == 110) {
							//errror on Nor140 connection
							this.$message({
								message: this.$l('codes/97'),
								type: 'error',
							});	
						} else {
							this.$message({
									//message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status,
									message: this.$l('settings/device/instrumentSent'),
									type: 'success',
									//customClass:'error-message-one'
								});
						}
						this.instrumentLoading = false;
					})
					.catch(err=>{
						this.instrumentLoading = false;
					})
				
			},1500)
		},
		restartNoiseClick(){
			 this.$confirm(this.$l('settings/device/restartNoise'), this.$l('settings/warning'),{
				confirmButtonText:this.$l('settings/continue'),
				cancelButtonText: this.$l('settings/cancel'),
				type: 'warning'
			}).then(() =>{

				this.$notify({
	                title: this.$l('common/Warning'),
	                message: this.$l('settings/status/Restart Warning'),
	                type: 'warning'
	            }); 

				this.restartLoading = true;
				setTimeout(()=>{
					
					restartNoise(this.$store)
						.catch(()=>{})
						.then((data)=>{
								if (data.error == 110) {
									//errror on Nor140 connection
									this.$message({
										message: this.$l('codes/97'),
										type: 'error',
									});	
								} else {
										this.$message({
											type: 'success',
											//message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status, //Ce obstaja prevod prevedi, drugače izpisi
											message: this.$l('settings/status/Restart success')
										});
								}
							this.restartLoading = false;

						})
				},1000)
				
			}).catch(()=>{
				this.$message({
					type:'info',
					message: this.$l('settings/status/Restart cancel')
				})
			})

		},
		formatSD(){ 
			this.$confirm(this.$l('settings/device/formatSDdialog'), this.$l('settings/warning'),{
				confirmButtonText:this.$l('settings/continue'),
				cancelButtonText: this.$l('settings/cancel'),
				type: 'warning'
			}).then(() =>{
				this.formatSDLoading = true;

				this.$notify({
	                title: this.$l('common/Warning'),
	                message: this.$l('settings/video/formatSDWarning'),
	                type: 'warning'
	            }); 
				setTimeout(()=>{
					sdFormatNoise(this.$store);
						/*.catch(()=>{})
						.then(()=>{
							this.$message({
								type: 'success',
								message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status, //Ce obstaja prevod prevedi, drugače izpisi
								//message: this.$l('settings/status/Restart success')
							});*/
							this.formatSDLoading = false;
						//})
				},1500)
			 }).catch(()=>{
				this.$message({
					type:'info',
					message: this.$l('settings/status/Restart cancel')
				})
			})
		},
		checkSD(){
			this.checkSpaceLoading = true;
			sdFreeNoise(this.$store)
					.then(data=>{
						setTimeout(()=>{
							if (data.error == 110) {
								//errror on Nor140 connection
								this.$message({
									message: this.$l('codes/97'),
									type: 'error',
								});	
							} else {
								this.$message({
									message: this.$l('settings/device/freeSpace')+data.data,
									//message: (this.$l(`common/${data.status}`).indexOf('N_T')==-1)?this.$l(`common/${data.status}`):data.status, //Ce obstaja prevod prevedi, drugače izpisi
									type: 'success',
									customClass:'error-message-one'
								});
							}
							this.checkSpaceLoading = false;
						},1500)
					})
					.catch(()=>{
						this.checkSpaceLoading = false;
					})
			
		},
		testOptions(){
			testOptions(this.$store)
				.then(data=>{
					this.testOptionsValue = data.data;
				})
		},
		getDeviceValueName(value){
			switch(value.length){
				case 3:
					var valueArray = value[0].split('');
					valueArray.splice(2,1);
					return valueArray.join('');
				case 2:
				case 1:
					return value[0];
				
			}
		},
		increaseClicked(){
			increaseVolume(this.$store)
				.then((data)=>{
					if (data.error == 110) {
							//errror on Nor140 connection
							this.$message({
								message: this.$l('codes/97'),
								type: 'error',
							});	
						} else {
							this.getSettingsDevice.meterscale = parseInt(this.getSettingsDevice.meterscale) + 10;
							this.$message({
								message: this.$l('settings/device/increasedVol'),
								//message: this.$l(`common/${data.status}`),
								type: 'success',
								//customClass:'error-message-one'
							});
						}
				})
		},
		decreaseClicked(){
			decreaseVolume(this.$store)
				.then((data)=>{
					if (data.error == 110) {
							//errror on Nor140 connection
							this.$message({
								message: this.$l('codes/97'),
								type: 'error',
							});	
						} else {
							this.getSettingsDevice.meterscale = parseInt(this.getSettingsDevice.meterscale) - 10;
							this.$message({
									message: this.$l('settings/device/decreasedVol'),
									//message: this.$l(`common/${data.status}`),
									type: 'success',
									//customClass:'error-message-one'
								});
						}
				})
		},
		checkboxChanged(value){
			var spectCount = 0;
			var ltCount = 0;
			this.getSettingsDevice.valsel.forEach(item=>{
				if(item.indexOf('f')>-1){
					spectCount++;
				}
				else{
					ltCount++;
				}
			})
			var spectMax = 0;
			var ltMax = 0;
			switch(this.getSettingsDevice.resolution){
				case 'UN50':
				case 'UN125':
				case 'UN500':{
					ltMax = 4;
					spectMax = 1
					break;
				}
				default:{
					ltMax = 8;
					spectMax = 2;
					break;
				}
			}
			for(var i = 0; i < ltCount-ltMax; i++){
				var item = this.getSettingsDevice.valsel.find(item=>item.indexOf('f') == -1);
				var index = this.getSettingsDevice.valsel.indexOf(item);
				if(index != -1)
					this.getSettingsDevice.valsel.splice(index,1);
			}
			for(var i = 0; i < spectCount-spectMax; i++){
				var item = this.getSettingsDevice.valsel.find(item=>item.indexOf('f') > -1);
				var index = this.getSettingsDevice.valsel.indexOf(item);
				if(index != -1)
					this.getSettingsDevice.valsel.splice(index,1);
			}
			if (this.getStatus.noise) {
				this.$message({
	            	message: this.$l('settings/device/warningMeasRunning'),
	                type: 'warning'
				});
			}
		},
		addStartstopGroup: function(){
			var groupId = 1;
			this.getSettingsStartstop.groups.forEach(g=>{
				var id = parseInt(g.replace('gr',''));
				if (id >= groupId){ groupId = id + 1;}
			})

			this.getSettingsStartstop.groups.push('gr'+groupId);
			this.getSettingsStartstop['daysgr'+groupId] = [];
			this.getSettingsStartstop['typesgr'+groupId] = [];
			this.getSettingsStartstop['startgr'+groupId] = '06:00';
			this.getSettingsStartstop['stopgr'+groupId] ='21:00';
			this.getSettingsStartstop['enablegr'+groupId] = false;


			this.updateStartstopSettings(JSON.parse(JSON.stringify(this.getSettingsStartstop)));
		},
		deleteStartstopGroup: function(group){
			var index = this.getSettingsStartstop.groups.indexOf(group);
			if (index > -1){
				this.getSettingsStartstop.groups.splice(index, 1);
				delete this.getSettingsStartstop['days'+group];
				delete this.getSettingsStartstop['types'+group];
				delete this.getSettingsStartstop['start'+group];
				delete this.getSettingsStartstop['stop'+group];
				delete this.getSettingsStartstop['enable'+group];

			}
		}

	},
	mounted: function(){
		setTimeout(()=>{
			var counter = 0;
			var delayedLoadingInterval = setInterval(()=>{
				this.delayedLoading[counter] = true;
				counter++;
				if(counter > 5) 
					clearInterval(delayedLoadingInterval);
			},0);
		},500)
	}
}
</script>


	


// WEBPACK FOOTER //
// Device.vue?2f91bcb2